module.exports = __webpack_public_path__ + "static/media/regioRad-leg.d477ed4f.svg";